import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetHandoverActivitiesQueryVariables = Types.Exact<{
  handoverId: Types.Scalars['String']['input'];
}>;


export type GetHandoverActivitiesQuery = { __typename?: 'query_root', get_handover_activity?: Array<{ __typename?: 'HandoverActivityItem', id: any, event_type: string, new_values?: any | null, old_values?: any | null, created_at: any, created_org_name?: string | null, created_property_name?: string | null, user: { __typename?: 'HandoverActivityUser', first_name: string, last_name: string, org_name?: string | null } } | null> | null };


export const GetHandoverActivitiesDocument = gql`
    query getHandoverActivities($handoverId: String!) {
  get_handover_activity(handover_id: $handoverId) {
    id
    user {
      first_name
      last_name
      org_name
    }
    event_type
    new_values
    old_values
    created_at
    created_org_name
    created_property_name
  }
}
    `;

/**
 * __useGetHandoverActivitiesQuery__
 *
 * To run a query within a React component, call `useGetHandoverActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHandoverActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHandoverActivitiesQuery({
 *   variables: {
 *      handoverId: // value for 'handoverId'
 *   },
 * });
 */
export function useGetHandoverActivitiesQuery(baseOptions: Apollo.QueryHookOptions<GetHandoverActivitiesQuery, GetHandoverActivitiesQueryVariables> & ({ variables: GetHandoverActivitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHandoverActivitiesQuery, GetHandoverActivitiesQueryVariables>(GetHandoverActivitiesDocument, options);
      }
export function useGetHandoverActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHandoverActivitiesQuery, GetHandoverActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHandoverActivitiesQuery, GetHandoverActivitiesQueryVariables>(GetHandoverActivitiesDocument, options);
        }
export function useGetHandoverActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHandoverActivitiesQuery, GetHandoverActivitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHandoverActivitiesQuery, GetHandoverActivitiesQueryVariables>(GetHandoverActivitiesDocument, options);
        }
export type GetHandoverActivitiesQueryHookResult = ReturnType<typeof useGetHandoverActivitiesQuery>;
export type GetHandoverActivitiesLazyQueryHookResult = ReturnType<typeof useGetHandoverActivitiesLazyQuery>;
export type GetHandoverActivitiesSuspenseQueryHookResult = ReturnType<typeof useGetHandoverActivitiesSuspenseQuery>;
export type GetHandoverActivitiesQueryResult = Apollo.QueryResult<GetHandoverActivitiesQuery, GetHandoverActivitiesQueryVariables>;